import React from "react";
import { Modal, ModalBody } from "reactstrap";

const ModalView = ({ close, setModal, children, isOpen }) => {
  return (
    <Modal
      size="lg"
      toggle={setModal}
      isOpen={isOpen}
      className="modal-dialog-centered"
      style={{ maxWidth: "700px", width: "100%" }}
    >
      <ModalBody>{children}</ModalBody>
    </Modal>
  );
};
export default ModalView;
